"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_csv_1 = require("react-csv");
const ExportCSV = ({ csvHeaders, csvData, fileName, title, }) => {
    return ((0, jsx_runtime_1.jsx)(react_csv_1.CSVLink, { headers: csvHeaders, data: csvData, filename: fileName, children: title }));
};
exports.default = ExportCSV;
